export const FINANCE_STATUS_TEXT = {
    open: {
        label: 'Em aberto',
        tone: 'info',
        what: 'Ainda não foi pago. Enquanto estiver em dia, é só o que está por vir.',
    },
    settled: {
        label: 'Quitado',
        tone: 'success',
        what: 'Pago por inteiro. As baixas ficam no histórico do título, com a data de cada uma.',
    },
    cancelled: {
        label: 'Cancelado',
        // Vermelho, e não cinza (F156): cancelar um título é o mesmo ato de
        // cancelar uma venda ou uma compra.
        tone: 'danger',
        what: 'O título foi desfeito e ninguém deve mais nada por ele. O motivo fica registrado.',
    },
};
export const overdueText = (daysOverdue) => ({
    label: daysOverdue === 1
        ? '1 dia atrasado'
        : `${String(daysOverdue)} dias atrasado`,
    tone: 'danger',
    what: 'Venceu e não foi pago. O número é de quantos dias, porque é disso que trata a cobrança.',
});
export const FINANCE_LEGEND_TEXT = [
    FINANCE_STATUS_TEXT.open,
    overdueText(3),
    FINANCE_STATUS_TEXT.settled,
    FINANCE_STATUS_TEXT.cancelled,
];
/**
 * De onde o título veio (F154). Saiu de `apps/web/src/lib/finance-labels.ts`
 * quando o celular passou a precisar das mesmas palavras (F310).
 */
export const FINANCE_ORIGIN_LABELS = {
    sale: 'Venda',
    purchase: 'Compra',
    manual: 'Lançado à mão',
    payroll: 'Folha de pagamento',
    tax: 'Imposto',
    exchange: 'Diferença de troca',
    renegotiation: 'Renegociação',
    commission: 'Comissão',
};
//# sourceMappingURL=finance.js.map